export default "/img/GY.386d0c989f5597392b31e320a3ce4c4c.png";